export enum RepaymentExitByType {
    Sale = 0,
    Refinance = 1,
    Other = 2,
    Unknown = 3,
}
